
import { Component, OnInit, ViewChild } from '@angular/core';
import { Validators, FormBuilder, FormControl, FormGroup, AbstractControl } from '@angular/forms';
import { RutValidator } from 'ng9-rut';

import { UserService } from '../../../services/user.service';

import { WizardComponent } from 'node_modules/angular-archwizard';

import { validateRutFactory } from 'ng9-rut';
import { rutValidate, rutClean } from 'rut-helpers';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
declare const swal: any;


@Component({
  selector: 'registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.css'],
  providers: [UserService]
})
export class RegistroComponent implements OnInit {
  @ViewChild('wizard', { static: true }) wizard: WizardComponent;
  public rutBuscar;
  public form;
  public user;
  public comunas;
  public regiones;
  public comunasFinal
  public btnclicked;

  public userform;
  constructor(private _userService: UserService, private fb: FormBuilder, private rutValidator: RutValidator, private spinner: NgxSpinnerService, public dialog: MatDialog) {

    this.userform = this.fb.group({
      busc_rut: ['', [Validators.required, rutValidator, Validators.minLength(8)]],
      //password: ['', [Validators.required]]
    })


    this.form = new FormGroup({
      rut: new FormControl(['', [Validators.required, rutValidator, Validators.minLength(8)]]),
      nombres: new FormControl('', [Validators.required, Validators.minLength(3)]),
      apellidoP: new FormControl('', [Validators.required, Validators.minLength(3)]),
      apellidoM: new FormControl('', [Validators.required, Validators.minLength(3)]),
      profesion: new FormControl(''),
      calle: new FormControl('', [Validators.required, Validators.minLength(3)]),
      numero: new FormControl('', [Validators.required, Validators.minLength(1),Validators.pattern(/[0-9]*/)]),
      complemento: new FormControl(''),
      telefono: new FormControl('', [Validators.required, Validators.minLength(7),Validators.maxLength(9),Validators.pattern(/[0-9]*/) ]),
      region: new FormControl('', [Validators.required, Validators.minLength(1)]),
      comuna: new FormControl('', [Validators.required, Validators.minLength(1)]),
      email: new FormControl('', [Validators.required, Validators.minLength(3), Validators.email]),
      passwords: this.fb.group({
        password: new FormControl('', [Validators.required, Validators.minLength(4)]),
        repassword: new FormControl('', [Validators.required, Validators.minLength(4)])
      },
        { validator: this.passwordConfirming }),
    })

    //{ validator: !this.matchingPasswords('password', 'repassword') })    





  }

  ngOnInit() {
    this.resetearForm()
    this.getRegiones();
    this.getComunas();
  }
  passwordConfirming(c: AbstractControl): { mismatchedPasswords: boolean } {
    if (c.get('password').value !== c.get('repassword').value) {
      return { mismatchedPasswords: true };
    }
  }


  buscarUsuario() {
    this.spinner.show();

    this.form.patchValue({
      rut: this.userform.value.busc_rut
    })
    //console.log('rut',this.userform.value.busc_rut)
    this._userService.buscarUsuario(rutClean(this.userform.value.busc_rut)).subscribe(
      response => {
        if (response.message) {
          this.spinner.hide();
          alert("El usuario ya existe")
        }
        if (response.register) {
          this.spinner.hide();
          this.wizard.navigation.goToNextStep();
        }

      },
      error => {
        let e = JSON.parse(error._body);
        alert(e.message);
        this.spinner.hide();
      }
    )
  }

  register() {




    //console.log('this.form.controls.passwords',this.form.controls.passwords.errors.mismatchedPasswords)
    //console.log('this.form.controls.passwords',this.form.controls.passwords)
    //console.log('this.form.controls.passwords.value.repassword.length',this.form.controls.passwords.value.repassword.length)

    if (this.form.valid) {
      this.spinner.show();
      this._userService.register(this.form).subscribe(
        response => {
          this.wizard.navigation.goToNextStep();
          //console.log('register', response);
          this.spinner.hide();
          this.resetearForm()
        },
        error => {
          let e = JSON.parse(error._body);
          alert(e.message);
          this.spinner.hide();
        }
      )
    } else {
      //console.log('btnclicked')      

      this.btnclicked = true;

      swal({
        type: 'error',
        title: "El formulario no es valido",
        showConfirmButton: true,
        confirmButtonText: 'Aceptar',
        allowOutsideClick: false
      }).then(() => {
        window.scroll(0, 0);
      });
    }



    

  }


  getComunas() {
    this._userService.getComunas().subscribe(
      response => {
        console.log('getComunas response', response)
        this.comunas = response
      },
      error => {
        let e = JSON.parse(error._body);
        alert(e.message);
      }
    )
  }

  getRegiones() {

    this.regiones = this._userService.getRegiones();
    // this._userService.getRegiones().subscribe(
    //   response => {
    //     console.log('getRegiones response', response)
    //     this.regiones = response
    //   },
    //   error => {
    //     let e = JSON.parse(error._body);
    //     alert(e.message);
    //   }
    // )
  }

  resetearForm() {
    this.form.controls['rut'].setValue('');
    this.form.controls['nombres'].setValue('');
    this.form.controls['apellidoP'].setValue('');
    this.form.controls['apellidoM'].setValue('');
    this.form.controls['profesion'].setValue('');
    this.form.controls['calle'].setValue('');
    this.form.controls['numero'].setValue('');
    this.form.controls['complemento'].setValue('');
    this.form.controls['telefono'].setValue('');
    this.form.controls['region'].setValue('');
    this.form.controls['comuna'].setValue('');
    this.form.controls['email'].setValue('');
    this.form.controls.passwords.controls['password'].setValue('');
    this.form.controls.passwords.controls['repassword'].setValue('');
  }

  cambiarComunas(region) {

    this.comunasFinal = [];
    let nRomanoRegion;
    let nRomanoComuna
    /*
        this.comunas.forEach(element => {
          //console.log('element.fieldData.COM_Region.toLowerCase()',element.fieldData.COM_Region.toLowerCase())
          //console.log('this.form.get("region").value.toLowerCase()',this.form.get('region').value.toLowerCase())
          //comuna.fieldData.COM_Region == //casilla region
    
          //console.log('this.regiones',this.regiones);
    
          let numeroRomano = this.quitarTildes(element.fieldData.COM_Region).split("-");//table comunas
          let numeroRomano2 = this.quitarTildes(this.form.get('region').value).split("-");//tabla regiones
    
          if (numeroRomano[0] == numeroRomano2[0]) {
            this.comunasFinal.push(element)
    
          } else {
            console.log(`región en table region ( ${ element.fieldData.COM_Region }) no coincide con la region en tabla comunas ( ${ this.form.get('region').value}) `)
            console.log(`región numero romano( ${ numeroRomano2 }) no coincide con la region en tabla comunas ( ${ numeroRomano}) `)
          }
        });*/

    this.regiones.data.forEach(elemento => {
      //console.log('elemento', elemento)
      if (this.quitarTildes(elemento.fieldData.region) == this.quitarTildes(this.form.get('region').value)) {
        nRomanoRegion = elemento.fieldData.REG_Numero.toLowerCase();
      }
    })
    this.comunas.forEach(element => {
      nRomanoComuna = this.quitarTildes(element.fieldData.COM_Region).split("-")[0];//table comunas
      // console.log('nRomanoRegion', nRomanoRegion)
      // console.log('nRomanoComuna', nRomanoComuna)
      if (nRomanoRegion == nRomanoComuna) {
        this.comunasFinal.push(element)
      } else {
        //console.log(`región en table region ( ${element.fieldData.COM_Region}) no coincide con la region en tabla comunas ( ${this.form.get('region').value}) `)
        //console.log(`región numero romano( ${nRomanoRegion}) no coincide con la region en tabla comunas ( ${nRomanoComuna}) `)
      }
    })
    if (this.comunasFinal.length == 0) { console.log(`campo region en tabla regiones ( ${nRomanoRegion}) no coincide con la region en tabla comunas ( ${nRomanoComuna}) `) }
    console.log('this.comunasFinal', this.comunasFinal)

  }

  quitarTildes(palabra: string) {
    palabra = palabra.toLowerCase()
    //console.log('palabra.replace(/á/gi,"a").replace(/é/gi,"e").replace(/í/gi,"i").replace(/ó/gi,"o").replace(/ú/gi,"u").replace(/ñ/gi,"n");',palabra.replace(/á/gi,"a").replace(/é/gi,"e").replace(/í/gi,"i").replace(/ó/gi,"o").replace(/ú/gi,"u").replace(/ñ/gi,"n"));
    return palabra.replace(/á/gi, "a").replace(/é/gi, "e").replace(/í/gi, "i").replace(/ó/gi, "o").replace(/ú/gi, "u").replace(/ñ/gi, "n");

  }

  finishRegister() {
    this.dialog.closeAll();
  }

}